import {Button, ButtonProps} from '@mui/material';
import React from 'react';

export const TextButton = React.forwardRef<HTMLButtonElement, ButtonProps>(function TextButton(props, ref) {
  const {sx, ...rest} = props;

  return (
    <Button
      ref={ref}
      variant='text'
      sx={[
        (theme) => ({
          ...theme.typography.body2,
          textTransform: 'none',
          color: 'maddox.globalblack',
          paddingX: 1,
          paddingY: 0.5,
          border: '1px solid transparent',
          '&:hover, &:focus-visible': {
            backgroundColor: 'maddox.hover',
            color: 'secondary.main',
          },
          '&:focus-visible, &:active': {
            borderColor: 'secondary.light',
          },
          '&:active': {
            color: 'secondary.dark',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {props.children}
    </Button>
  );
});
